import {askPopupRequest, sendPopupRequest} from '../../../utils/portuna';
import CalendarEntryViewPopup from '../../../views/calendar/entry/CalendarEntryViewPopup.vue';
import ServiceEntryInformPopUpRequest from '../../../views/services/calendar/components/ServiceEntryInformPopUpRequest.vue';
import AnonymizeEntries from '../../../views/services/settings/components/AnonymizeEntries.vue';
import {exportEnabled} from '../../export';
import {subjectGenus} from '../../grammar';
import {Popup, popupDefaultCloseButton} from '../../popup';
import {parsePlaceholders} from '../../string';

export const PRIVACY_TEXT_DEFAULT = 'Auf unserer Webseite haben Sie die Möglichkeit Termine online zu buchen. Dazu nutzen wir das Terminbuchungstool der PortUNA Neue Medien GmbH (nachfolgend „PortUNA“). Beim Aufruf der Terminbuchung werden Logfiles (angefragte Seite, Referrer, Datum und Uhrzeit der Serveranfrage, Status der Serverabfrage, übertragende Datenmenge,IP-Adresse und User-Agent (Browser & Betriebssystem)) für maximal 7 Tage bei der PortUNA gespeichert und anschließend gelöscht. Die Speicherung der Daten erfolgt allein aus Sicherheitsgründen, um z. B. Missbrauchsfälle aufklären zu können. Rechtsgrundlage dazu ist Art. 6 Abs. 1 lit. f. DS-GVO.'
    + '<br>'
    + '<br>'
    + 'Sollten Sie die Funktion der Terminbuchung nutzen, so werden die Pflichtangaben (mit einem Stern (*) gekennzeichneten Felder) auf der Grundlage von Art. 6 Abs. 1 S. 1 lit. b DS-GVO verarbeitet, da diese für die Nutzung des Dienstes notwendig sind. Freiwillige oder zusätzliche Angaben werden auf Grundlage von Art. 6 Abs. 1 S. 1 lit. a DS-GVO verarbeitet, wo die Einwilligung jederzeit widerrufen werden kann. Ihre Daten werden nur so lange gespeichert und verarbeitet, wie es zur Erfüllung der vertraglichen oder gesetzlichen Pflichten notwendig ist oder der Zweck der Datenspeicherung entfällt. Anschließend werden Ihre Daten gelöscht, es sei denn, es bestehen gesetzliche Aufbewahrungspflichten, die einer Löschung entgegenstehen.'
    + '<br>'
    + '<br>'
    + 'Wir haben mit der PortUNA Neue Medien GmbH ein Auftragsverarbeitungsvertrag abgeschlossen, der die PortUNA Neue Medien GmbH verpflichtet, die personengebundenen Daten nur nach unseren Weisungen und unter Einhaltung der DS-GVO zu verarbeiten.'
    + '<br>'
    + '<br>'
    + 'Die Datenschutzerklärung der PortUNA bzgl. der Terminbuchung finden Sie hier:<br>'
    + '<a href="https://www.portuna.de/buchungswebseite/datenschutz">https://www.portuna.de/buchungswebseite/datenschutz</a>';

export const PRIVACY_TYPE_DEFAULT: 0     = 0;
export const PRIVACY_TYPE_BY_LINK: 1     = 1;
export const PRIVACY_TYPE_BY_OWN_TEXT: 2 = 2;

export const PRIVACY_TYPE_OPTIONS: SelectOption[] = [
    {
        label: 'Standardtext (nicht empfohlen!)',
        value: 0,
    },
    {
        label: 'per Link (empfohlen)',
        value: 1,
    },
    {
        label: 'per Text',
        value: 2,
    },
];

export const TYPE_CALENDAR_ENTRY                = 0;
export const TYPE_CALENDAR_UNAVAILABILITY_ENTRY = 1;
export const TYPE_CALENDAR_CUSTOM_ENTRY         = 2;

export const CALENDAR_SELECTION_MANUAL      = 1;
export const CALENDAR_SELECTION_LOWEST_LOAD = 2;
export const CALENDAR_SELECTION_SEQUENTIAL  = 3;
export const CALENDAR_SELECTION_RANDOM      = 4;

export const REMINDER_DEACTIVATED             = 1;
export const REMINDER_ONE_HOUR                = 2;
export const REMINDER_TWO_HOURS               = 3;
export const REMINDER_FOUR_HOURS              = 4;
export const REMINDER_EIGHT_HOURS             = 5;
export const REMINDER_TWELVE_HOURS            = 6;
export const REMINDER_ONE_DAY                 = 7;
export const REMINDER_TWO_DAYS                = 8;
export const REMINDER_THREE_DAYS              = 9;
export const REMINDER_FOUR_DAYS               = 10;
export const REMINDER_FIVE_DAYS               = 11;
export const REMINDER_ONE_WEEK                = 12;
export const REMINDER_TWO_WEEKS               = 13;
export const REMINDER_OPTIONS: SelectOption[] = [
    {
        value: REMINDER_DEACTIVATED,
        label: 'Deaktiviert',
    },
    {
        value: REMINDER_ONE_HOUR,
        label: '1 Stunde vor Terminbeginn',
    },
    {
        value: REMINDER_TWO_HOURS,
        label: '2 Stunden vor Terminbeginn',
    },
    {
        value: REMINDER_FOUR_HOURS,
        label: '4 Stunden vor Terminbeginn',
    },
    {
        value: REMINDER_EIGHT_HOURS,
        label: '8 Stunden vor Terminbeginn',
    },
    {
        value: REMINDER_TWELVE_HOURS,
        label: '12 Stunden vor Terminbeginn',
    },
    {
        value: REMINDER_ONE_DAY,
        label: '1 Tag vor Terminbeginn',
    },
    {
        value: REMINDER_TWO_DAYS,
        label: '2 Tage vor Terminbeginn',
    },
    {
        value: REMINDER_THREE_DAYS,
        label: '3 Tage vor Terminbeginn',
    },
    {
        value: REMINDER_FOUR_DAYS,
        label: '4 Tage vor Terminbeginn',
    },
    {
        value: REMINDER_FIVE_DAYS,
        label: '5 Tage vor Terminbeginn',
    },
    {
        value: REMINDER_ONE_WEEK,
        label: '1 Woche vor Terminbeginn',
    }, {
        value: REMINDER_TWO_WEEKS,
        label: '2 Wochen vor Terminbeginn',
    },
];

export const CUSTOM_DESCRIPTION_POSITION_TOP     = 0;
export const CUSTOM_DESCRIPTION_POSITION_BOTTOM  = 1;
export const CUSTOM_DESCRIPTION_POSITION_REPLACE = 2;

export const HELP_TEXT_PRIVACY_ANONYMIZE: string = 'Mit Aktivierung dieser Option legen Sie fest, dass '
    + '<strong>alle zurückliegenden Termine</strong> automatisch nach X Tagen/Monaten <strong>anonymisiert</strong> werden.<br>'
    + 'Dabei werden alle persönlichen Daten <strong>unwiderruflich</strong> gelöscht.'
    + '<br/>'
    + '<br/>'
    + 'Die automatische Anonymisierung der Termine wird vom System ab dem nächsten Tag 1x täglich um ca. 6 Uhr vorgenommen.';

export const PERIOD_TYPE_OPTIONS: SelectOption[] = [
    {
        value: 0,
        label: 'Tag(en)',
    },
    {
        value: 1,
        label: 'Monat(en)',
    },
];

export function deleteService(entry: ServiceData, options: ServiceCalendarResourceOptions): Promise<any>
{
    let message = 'Sind Sie sicher, dass Sie %articleAccusativeSingular%'
        + ' ' + options.serviceType + '  <strong>' + entry.title + '</strong> löschen möchten?<br><br>'
        + 'Hinweis: Bereits gebuchte Termine werden nicht gelöscht.';

    message = replaceArticles(message, options.serviceGenusType);

    return sendPopupRequest({
        type: 'delete',
        url: '/services/services/delete',
        data: {
            id: entry.id,
        },
        message: {
            headline: options.serviceType + ' löschen',
            message,
        },
        options: {
            textIcon: 'delete_forever',
            textIconClass: 'text-danger',
            titleIcon: 'delete',
            buttonOkay: {
                type: 'danger',
                icon: 'delete',
                title: 'Löschen',
            },
        },
    });
}

export function changeStatus(entry: ServiceData, options: ServiceCalendarResourceOptions): Promise<any>
{
    let icon = (entry.active ? 'remove_circle' : 'check_circle');

    let message = 'Sind Sie sicher, dass Sie %articleAccusativeSingular%'
        + ' '
        + options.serviceType
        + '  <strong>'
        + entry.title
        + '</strong> '
        + (entry.active ? 'deaktivieren' : 'aktivieren')
        + ' möchten? <br><br>'
        + 'Deaktivierte '
        + options.serviceTypePlural
        + ' finden Sie in Ihrem Terminbuchungstool, werden allerdings nicht auf Ihrer Buchungswebseite angezeigt und sind somit nicht für Ihre Kunden buchbar. '
        + '<br><br>'
        + 'Wenn Sie %countableNoun% deaktivierte '
        + (options.serviceGenusType === 'masculine' ? 'n' : (options.serviceGenusType === 'neuter' ? 's' : ''))
        + ' '
        + options.serviceType
        + ' wieder aktivieren, wird %demonstrativePronounNominativ% wieder auf Ihrer Buchungswebseite angezeigt und kann wieder von Ihren Kunden gebucht werden.';

    message = replaceArticles(message, options.serviceGenusType);

    return sendPopupRequest({
        type: 'changeStatus' + (entry.active ? 'deactivate' : 'activate'),
        url: '/services/services/changeStatus',
        data: {
            id: entry.id,
        },
        message: {
            headline: options.serviceType + ' ' + (entry.active ? 'deaktivieren' : 'aktivieren'),
            message,
        },
        options: {
            textIcon: icon,
            titleIcon: icon,
            buttonOkay: {
                type: entry.active ? 'danger' : 'success',
                icon: icon,
                title: entry.active ? 'Deaktivieren' : 'Aktivieren',
            },
        },
    });
}

export function calendarEntryView(entry: CalendarEntryListData, calendar: CalendarData, defaultResource: CalendarResources, additionalData: AdditionalCalendarData, deleteCallback: VoidFunction)
{
    let buttons: PopupButton[];

    const resource = 'services';
    const id       = entry.id.toString();
    const start    = entry.recurrence_start;

    if (entry.editable)
    {
        buttons = [popupDefaultCloseButton];

        if (entry.entry_type !== TYPE_CALENDAR_UNAVAILABILITY_ENTRY)
        {
            buttons.push({
                title: 'Details',
                icon: 'visibility',
                type: 'primary',
                to: entry.viewLink || {
                    name: resource + '-entry-' + (additionalData.isServiceEntry ? 'view' : 'unavailability-view'),
                    params: {
                        id,
                        start,
                    },
                },
            });
        }

        buttons.push(
            {
                title: 'Bearbeiten',
                icon: 'edit',
                type: 'warning',
                to: {
                    name: resource + '-entry-' + (additionalData.isServiceEntry ? 'edit' : 'unavailability'),
                    params: {
                        id,
                        start,
                    },
                },
            },
            {
                title: 'Löschen',
                icon: 'delete',
                type: 'danger',
                cmd: (popup) =>
                {
                    popup.close();
                    deleteCallback();
                },
            },
        );
    }
    else if (!exportEnabled() && !entry.no_link && entry.id)
    {
        buttons = [
            popupDefaultCloseButton,
            {
                title: 'Details',
                icon: 'visibility',
                type: 'primary',
                to: entry.viewLink || {
                    name: resource + '-entry-view',
                    params: {
                        id,
                        start,
                    },
                },
            },
        ];
    }
    else
    {
        buttons = [popupDefaultCloseButton];
    }

    let popup = new Popup({
        title: additionalData.isServiceEntry ? (entry.is_reservation ? 'Reservierung' : 'Informationen') : entry.title,
        size: 'medium',
        buttons: buttons,
        component: CalendarEntryViewPopup,
        componentProps: {
            resource: 'services',
            entry,
            calendar,
            additionalData: additionalData,
        },
        titleIcon: 'event_note',
    });

    popup.open();
}

export function isServicesCalenderEntry(entry: CalendarEntryData)
{
    return entry.resource === 'services' && (entry.entry_type === TYPE_CALENDAR_ENTRY || entry.entry_type === TYPE_CALENDAR_CUSTOM_ENTRY);
}

export function isServicesCalenderCustomEntry(entry: CalendarEntryData)
{
    return entry.resource === 'services' && entry.entry_type === TYPE_CALENDAR_CUSTOM_ENTRY;
}

export function replaceArticles(replaceString: string, genus: GenusType)
{
    const placeholders = Object.assign(<object>subjectGenus[genus], {}) as Record<string, string>;

    return parsePlaceholders(replaceString, placeholders);

}

export function getServiceNames(entry: CalendarEntryData, withDuration: boolean, additionalData: AdditionalCalendarData): string[]
{
    let serviceNames: string[] = [];

    if (!entry.services || !entry.services.length)
    {
        return serviceNames;
    }

    for (const service of entry.services)
    {
        serviceNames.push(getServiceName(service, false, additionalData));
    }

    return serviceNames;
}

export function getServiceName(id: number, withDuration: boolean, additionalData: AdditionalCalendarData, people: number = 1, allowMultiplePeople: boolean = false)
{
    if (!id || !(additionalData.services?.services && Object.keys(additionalData.services.services).length > 0) || !additionalData.services.services[id])
    {
        return '';
    }

    const service = additionalData.services.services[id];

    let modified = '';

    if (service.is_deleted)
    {
        modified = ' (gelöscht)';
    }
    else if (!service.active)
    {
        modified = ' (deaktiviert)';
    }

    if (withDuration && service.duration)
    {
        return service.title + ` (${allowMultiplePeople ? `pro Teilnehmer ${service.duration} min, ` : ''}Gesamtdauer ${service.duration * people} min)` + modified;
    }

    return service.title + modified;
}

export function revertTemplateToDefault(mailTemplate: ServiceMailTemplateEntry): Promise<any>
{
    return new Promise((resolve, reject) =>
    {
        sendPopupRequest({
            type: 'delete',
            url: '/services/services/revert-mail-template-to-default/type/' + mailTemplate.type + '/id/' + mailTemplate.id,
            message: {
                headline: 'Standard wiederherstellen',
                message: 'Sind Sie sicher, dass Sie den Standardtext wiederherstellen möchten?',
                loader: 'Standard-E-Mail-Vorlage wird wiederhergestellt...',
            },
            options: {
                titleIcon: 'undo',
                textIconClass: 'text-warning',
                buttonOkay: {
                    title: 'Wiederherstellen',
                    icon: 'undo',
                    type: 'warning',
                },
            },
        })
        .then(resolve)
        .catch(reject);
    });
}

export function displayAnonymizeAllApplicationsWarning(): Promise<{ trigger: string }>
{
    return new Promise((resolve, reject) =>
    {
        let popup = new Popup({
            size: 'medium',
            component: AnonymizeEntries,
            title: 'Automatisches Anonymisieren aktivieren',
            titleIcon: 'info',
            textIcon: 'info',
            textIconClass: 'text-grey',
            onClose: () =>
            {
                reject('popupClosed');
            },
            events: {
                confirmed: () =>
                {
                    let resolveData = {
                        trigger: 'confirmed',
                    };

                    resolve(resolveData);
                },
            },
        });

        popup.open();
    });
}

export function confirmChangeInformClient(modifyEntry: CalendarEntryListData, options: PopupOptions = {}): Promise<void>
{
    return new Promise((resolve, reject) =>
    {
        if (!modifyEntry.email)
        {
            resolve();
            return;
        }

        let notifyClient = 1;
        let message      = options.text || 'Die Terminzeit wurde geändert, möchten Sie den Kunden per E-Mail informieren?';

        askPopupRequest({
            type: 'confirm',
            message: {
                headline: options.title || 'Termin geändert',
                message,
            },
            options: Object.assign({
                textIcon: 'email',
                textIconClass: 'text-success',
                titleIcon: 'send',
                buttonOkay: {
                    type: 'save',
                    icon: 'save',
                    title: 'Speichern',
                },
                component: ServiceEntryInformPopUpRequest,
                componentProps: {
                    value: notifyClient,
                },
            }, options),
        })
        .then(() => resolve())
        .catch(reject);
    });
}

